import { isInRange } from "@project-rouge/rg-core";
import { moveOutOfRange } from "@project-rouge/rg-three";
var SAFEGUARD = 1e3;
function positionOutOfCollision(pos, openingsRanges, doorSize) {
	const covered = [Infinity, -Infinity];
	let ranges = openingsRanges.filter((o) => isInRange(pos[0] + doorSize[2] * .5, o[0], o[1]) || isInRange(pos[0] - doorSize[2] * .5, o[0], o[1]));
	let iterations = 0;
	while (ranges.length > 0 && iterations < SAFEGUARD) {
		const maxRange = [Math.min(...ranges.map((v) => v[0])), Math.max(...ranges.map((v) => v[1]))];
		covered[0] = Math.min(covered[0], maxRange[0]);
		covered[1] = Math.max(covered[1], maxRange[1]);
		pos[0] = moveOutOfRange(pos[0], covered, doorSize[2] + .1);
		ranges = openingsRanges.filter((o) => isInRange(pos[0] + doorSize[2] * .5, o[0], o[1]) || isInRange(pos[0] - doorSize[2] * .5, o[0], o[1]));
		iterations++;
	}
	return pos;
}
export { positionOutOfCollision };

//# sourceMappingURL=index45.js.map